import Papa from 'papaparse'

/**
 * Export tabular data to a CSV file and trigger a download.
 * @param data - Row/column values to export
 * @param fileName - Base filename without extension
 */
export function exportCsv(data: (string | number)[][], fileName = 'data') {
  downloadFile({
    fileName: `${fileName}.csv`,
    fileDataString: Papa.unparse(data),
  })
}

export function downloadFile({
  fileName,
  fileDataType = 'data:text/plain;charset=utf-8',
  fileDataString,
}: {
  fileDataType?: string
  fileDataString: string
  fileName: string
}) {
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    [fileDataType, encodeURIComponent(fileDataString)].join(),
  )
  element.setAttribute('download', fileName)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export function downloadJson(fileName: string, json: object) {
  downloadFile({
    fileName,
    fileDataString: JSON.stringify(json, null, 2),
    fileDataType: 'data:text/json;charset=utf-8',
  })
}

export function downloadCsv(fileName: string, data: string[][]) {
  downloadFile({
    fileName,
    fileDataString: Papa.unparse(data),
    fileDataType: 'data:text/csv;charset=utf-8',
  })
}

export function openInNewTab({
  data,
  mimeType = 'application/json',
}: {
  data: object | string
  mimeType?: string
  filename?: string
}) {
  const content =
    typeof data === 'string' ? data : JSON.stringify(data, null, 2)
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
